import { ACTION_LOG_STATUS } from "@/@core/data/enum/actionLogStatus";
import {ACTION_EINVOICE_LOG_STATUS} from '@/@core/data/enum/actionEInvoiceLog';
import {ACTION_ENUM} from '@/@core/data/enum/actionCodeMap';
import flatPickr from "vue-flatpickr-component";
import dayjs from "dayjs";
import { getSystemLog,getActionMenu } from "@/api/action-defines/systemLog";
import { mapGetters } from "vuex";
import { getInfoUser } from "@/api/action-defines/site-management";
import { getGroupRoleListApi } from "@/api/action-defines/user-management";
import LogTable from '@/views/modules/action-log/LogTable/LogTable.vue';
export default {
  name: "ActionLog",
  components: {
    flatPickr,
    LogTable,
  },
  data() {
    return {
      logStatus: { ...ACTION_LOG_STATUS },
      logEinvoiceStatus: {...ACTION_EINVOICE_LOG_STATUS},
      buttonDisabled: "expand",
      dateRangeConfig: {
        mode: "range",
        locale: { rangeSeparator: " -> " },
        enableTime: true,
        time_24hr: true,
        dateFormat: "d/m/Y H:i",
      },
      dateRange: null,
      searchData: {
        FromDate: null,
        ToDate: null,
        Action: [],
        CreatedBy: [],
      },
      listAction1: [],
      listAction2: [],
      listAction3: [],
      listCreatedBy: [],
      logData: [],
      //Pagination
      paging: {
        PageSize: 20,
        PageIndex: 1,
      },
      totalPagination: {
        TotalRecord: 0,
        TotalPage: 0,
      },
    };
  },
  async created() {
  await this.load();
  await this.getActionMenuLoad();

  const now = dayjs(); // thời gian hiện tại
  const endOfToday = dayjs().endOf('day'); // 23:59:59 ngày hiện tại

  const formattedNow = now.format("DD/MM/YYYY HH:mm");
  const formattedEnd = endOfToday.format("DD/MM/YYYY HH:mm");

  this.dateRange = `${formattedNow} -> ${formattedEnd}`;
  this.searchData.FromDate = now.toISOString();
  this.searchData.ToDate = endOfToday.toISOString();

  await this.getLogs(); // gọi sau khi set date mặc định
},

  methods: {
    async load() {
      try {
        const res = await getInfoUser(); // Gọi API
        if (res.StatusCode === "200") {
          this.listCreatedBy = res.Data.map((user) => ({
            value: user.UserId,
            text: user.FullName || user.Email, // Hiển thị FullName nếu có, nếu không thì Email
          }));
          // this.listAction = [{value: 1, text: "test1"}, {value: 2, text: "test2"}, {value: 3, text: "test3"}]
        }
      } catch (error) {
        console.error("Error loading users:", error);
      }
    },
    async getActionMenuLoad() {
      try {
        const res = await getActionMenu();
        if (res.StatusCode === "200" && Array.isArray(res.Data)) {
          const menuData = res.Data;

          // Gán vào từng danh sách theo Value
          const invoiceMenu = menuData.find(item => item.Value === "Invoice");
          const logMenu = menuData.find(item => item.Value === "LogAction");
          const configMenu = menuData.find(item => item.Value === "Config");

          // Map cho listAction1: Invoice
          this.listAction1 = invoiceMenu?.Childs?.map(child => ({
            value: child.Value,
            text: child.Text,
            childs: [] // không có cấp con tiếp theo
          })) || [];

          // Map cho listAction2: LogAction
          this.listAction2 = logMenu?.Childs?.map(child => ({
            value: child.Value,
            text: child.Text,
            childs: []
          })) || [];

          // Map cho listAction3: Config (có 3 cấp)
          this.listAction3 = configMenu?.Childs?.map(group => ({
            value: group.Value,
            text: group.Text,
            childs: group.Childs?.map(child => ({
              value: child.Value,
              text: child.Text
            })) || []
          })) || [];
        }
      } catch (error) {
        console.error("Error loading action menu:", error);
      }
    },
    async getLogs() {
      // if(!this.dateRange) {
      //   this.searchData.FromDate = null;
      //   this.searchData.ToDate = null;
      // }
      const mappedActions = this.searchData.Action
        .flatMap(code => ACTION_ENUM[code] ?? []) // nếu không có thì trả về []
        .filter(id => typeof id === 'number');    // loại bỏ undefined hoặc null
          this.setSearchDate();
          const BodyData = {
            ...this.searchData,
            Action: mappedActions, // BE yêu cầu List<int?>
            ...this.paging,
          };
      await getSystemLog({ BodyData }).then((res) => {
        if (res.StatusCode === "200") {
          this.logData = res.Data;
          this.logData.map((log) => {
            this.$set(log, "isCollapsed", false);
            log.CreatedDate = dayjs(log.CreatedDate).format("DD/MM/YYYY HH:mm");
          });
        }
      });
    },
    changePage(paging) {
      this.paging = paging;
    },

    isObjectEmpty(obj) {
      if (!obj) return false;
      if (typeof obj !== "object") return false;
      return Object.keys(obj).length === 0;
    },

    collapseAll() {
      this.logData.map((log) => {
        log.isCollapsed = true;
        this.$set(log, "isCollapsed", true);
      });
      this.buttonDisabled = "collapse";
    },

    expandAll() {
      this.logData.map((log) => {
        log.isCollapsed = false;
        this.$set(log, "isCollapsed", false);
      });
      this.buttonDisabled = "expand";
    },

    toggleCollapseLogRow(log) {
      log.isCollapsed = !log.isCollapsed;
    },

    searchActionLog() {
      this.getLogs();
    },
    setSearchDate() {
      if (!this.dateRange || typeof this.dateRange !== "string") return;

      const dateRange = this.dateRange.split("->");
      if (!dateRange[0] || !dateRange[1]) return;

      this.searchData.FromDate = dayjs(dateRange[0].trim(), "DD/MM/YYYY HH:mm").toISOString();
      this.searchData.ToDate = dayjs(dateRange[1].trim(), "DD/MM/YYYY HH:mm").toISOString();
    },
    getActionLogStatusUI(statusId) {
      if (!this.logStatus) return;
      let status = {};

      switch (statusId) {
        case 1:
          status = ACTION_LOG_STATUS.CHANGED;
          break;
        case 2:
          status = ACTION_LOG_STATUS.ADDED;
          break;
        case 3:
          status = ACTION_LOG_STATUS.DELETED;
          break;
        default:
          break;
      }

      if (!status) return;

      return {
        ...status,
        text: this.$t(status.text),
      };
    },
    getActionEInvoiceStatusUI(statusId) {
      if (!this.logEinvoiceStatus) return '';

      let key = null;

      switch (statusId) {
        case 1:
          key = ACTION_EINVOICE_LOG_STATUS.ISSUE_INVOICE_WITHOUT_SIGNATURE;
          break;
        case 2:
          key = ACTION_EINVOICE_LOG_STATUS.CREATE_DRAFT_INVOICE;
          break;
        case 3:
          key = ACTION_EINVOICE_LOG_STATUS.EDIT_UNSIGNED_INVOICE;
          break;
        case 4:
          key = ACTION_EINVOICE_LOG_STATUS.DELETE_UNSIGNED_INVOICE;
          break;
        // case 5:
        //   key = ACTION_EINVOICE_LOG_STATUS.ISSUE_AND_SIGN_INVOICE;
        //   break;
        case 6:
          key = ACTION_EINVOICE_LOG_STATUS.REPLACE_SIGNED_INVOICE;
          break;
        case 7:
          key = ACTION_EINVOICE_LOG_STATUS.ADJUST_SIGNED_INVOICE;
          break;
        // case 8:
        //   key = ACTION_EINVOICE_LOG_STATUS.INCREASE_PRODUCT_PRICE_IN_SIGNED_INVOICE;
        //   break;
        // case 9:
        //   key = ACTION_EINVOICE_LOG_STATUS.DECREASE_PRODUCT_PRICE_IN_SIGNED_INVOICE;
        //   break;
        // case 10:
        //   key = ACTION_EINVOICE_LOG_STATUS.ADJUST_INFOR_INVOICE;
        //   break;
        case 12:
          key = ACTION_EINVOICE_LOG_STATUS.SIGN_INVOICE;
          break;
        default:
          return '';
      }

      return this.$t(key);
    },
    activeObject(oldObj, newObj) {
      if (!this.isObjectEmpty(oldObj) && oldObj) {
        return oldObj;
      }
      if (!this.isObjectEmpty(newObj) && newObj) {
        return newObj;
      }
      return {};
    },
  },
  computed: {
    ...mapGetters({
      $ls_CurrentSiteID: "auth/currentSiteID",
    }),
  },
};
